module.exports = __webpack_public_path__ + "assets/GoldenSectionDetailed.55e540260a2c189dafde9655cd54643d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/GoldenSectionDetailed.png
// module id = 517
// module chunks = 0